(function () {
  // --- Quick "Add" for add-on variants ---
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.ProductAddons__btn');
    if (!btn) return;

    const variantId = Number(btn.dataset.variantId);
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add to cart failed');

      // Ping common theme events so drawers/counters refresh if present
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      btn.textContent = 'Added!';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 900);
    } catch (err) {
      console.error(err);
      btn.textContent = 'Try again';
      btn.disabled = false;
    }
  });

  // --- Carousel controls ---
  function setupAddonsCarousels(root = document) {
    root.querySelectorAll('.ProductAddons--carousel .ProductAddons__viewport').forEach((viewport) => {
      const id = viewport.id;
      const wrap = viewport.closest('.ProductAddons');
      const prev = wrap.querySelector(`.ProductAddons__nav[data-target="${id}"][data-dir="-1"]`);
      const next = wrap.querySelector(`.ProductAddons__nav[data-target="${id}"][data-dir="1"]`);

      const step = () => Math.max(viewport.clientWidth * 0.9, 250);

      const update = () => {
        const max = viewport.scrollWidth - viewport.clientWidth - 1;
        if (prev) prev.disabled = viewport.scrollLeft <= 1;
        if (next) next.disabled = viewport.scrollLeft >= max;
        // Hide controls if no overflow
        if (prev && next) {
          const overflow = viewport.scrollWidth > viewport.clientWidth + 2;
          prev.style.display = overflow ? '' : 'none';
          next.style.display = overflow ? '' : 'none';
        }
      };

      if (prev) prev.addEventListener('click', () =>
        viewport.scrollBy({ left: -step(), behavior: 'smooth' })
      );
      if (next) next.addEventListener('click', () =>
        viewport.scrollBy({ left: step(), behavior: 'smooth' })
      );

      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAddonsCarousels());
  } else {
    setupAddonsCarousels();
  }
  // Support live reloads in the Theme Editor
  document.addEventListener('shopify:section:load', (e) => setupAddonsCarousels(e.target));
})();
